export default __webpack_public_path__ + "static/media/umbrella_menu_item.7a8d29e5.svg";